import { render, staticRenderFns } from "./rect-loading.vue?vue&type=template&id=b73e09be&"
import script from "./rect-loading.vue?vue&type=script&lang=js&"
export * from "./rect-loading.vue?vue&type=script&lang=js&"
import style0 from "./rect-loading.vue?vue&type=style&index=0&id=b73e09be&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports